import React, { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import { collection, getDocs, GeoPoint, addDoc } from "firebase/firestore";
import { firestore, GeoFirestore } from "../firebase";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import cities from "cities.json";

const auth = getAuth();
const db = firestore;

const RADIUS_KM = 30; // Adjust as needed

function getDistanceKm(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

const GetCityLocationsAdmin = () => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userAccess, setUserAccess] = useState(false);
  const [cityQuery, setCityQuery] = useState("");
  const [citySuggestions, setCitySuggestions] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const [addCity, setAddCity] = useState(false);
  const [newCityName, setNewCityName] = useState("");
  const [newCityLat, setNewCityLat] = useState("");
  const [newCityLng, setNewCityLng] = useState("");

  // Check auth on mount
useEffect(() => {
  const unsubscribe = auth.onAuthStateChanged((user) => {
    if (!user) {
      setUserAccess(false);
    } else {
      setUserAccess(true);
    }
  });
  return () => unsubscribe();
}, []);

  // Filter city suggestions as user types
  useEffect(() => {
    if (cityQuery.length < 2) {
      setCitySuggestions([]);
      return;
    }
    const lower = cityQuery.toLowerCase();
    const matches = cities
      .filter((c) => c.name.toLowerCase().startsWith(lower))
      .slice(0, 20); // Limit to 20 suggestions
    setCitySuggestions(matches);
  }, [cityQuery]);

  const handleSelectCity = async (city) => {
  setSelectedCity(city);
  setCityQuery(city.name);
  setNewCityName(city.name);
  setNewCityLat(city.lat);
  setNewCityLng(city.lng);
  if(addCity) return; // Don't fetch locations if adding a city
  setCitySuggestions([]);
  setLoading(true);

  try {
    const geocollection = GeoFirestore.collection("lokasjoner");

    const query = geocollection.near({
      center: new GeoPoint(parseFloat(city.lat), parseFloat(city.lng)),
      radius: RADIUS_KM,
    });

    const snapshot = await query.get();
    const nearby = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
      _distanceKm: doc.distance?.toFixed(1),
    }));

    nearby.sort((a, b) => a._distanceKm - b._distanceKm);
    setLocations(nearby);
  } catch (error) {
    console.error("Error fetching locations:", error);
  } finally {
    setLoading(false);
  }
};

  const handleAddCity = async () => {
    if (!newCityName || !newCityLat || !newCityLng) {
      alert("Please fill in all fields for the new city.");
      return;
    }
    console.log("Adding new city:", {
      name: newCityName,
      lat: newCityLat,
      lng: newCityLng,
    });
    const geoCityCollections = GeoFirestore.collection("cities");
    const newCityRef = await geoCityCollections.add({
      name: newCityName,
      lat: parseFloat(newCityLat),
      lng: parseFloat(newCityLng),
      coordinates: new firebase.firestore.GeoPoint(parseFloat(newCityLat), parseFloat(newCityLng)),
      radius_km: 25,
      build_status: "lite",  // "empty" | "lite" | "full"
    });
    console.log("New city added with ID:", newCityRef.id);
    // Here you would typically send this data to your backend or database
  };

  const sendPushNotification = async () => { //testet og fungerer
            await fetch(
          "https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/sendPushToCitySubscribers",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              organizerId: "T5tly39suxYTv7lAmhQ1",
              title: `Paris blir nå fylt ut`,
              body: `Vi har hørt etter og prioriterer å få lagt inn alle Paris restauranter i Mapli!`,
              data: {
                deepLink: `https://app.mapli.no/`,
                },
            }),
          },
        );
      }

  if (userAccess === false) return <p>Du har ikke tilgang til denne siden.</p>;

  return (
    <div>
      <div style={{ position: "relative", display: "inline-block" }}>
        <input
          type="text"
          placeholder="Søk etter by..."
          value={cityQuery}
          onChange={(e) => {
            setCityQuery(e.target.value);
            setSelectedCity(null);
            setLocations([]);
          }}
        /> <label>Add City: </label> <input type="checkbox" checked={addCity} onChange={(e) => setAddCity(e.target.checked)} style={{ width: "16px", height: "16px" }} />
        {addCity && ( <button onClick={handleAddCity}>Add City</button> )}
        {citySuggestions.length > 0 && (
          <ul style={{
            position: "absolute",
            background: "white",
            border: "1px solid #ccc",
            listStyle: "none",
            margin: 0,
            padding: 0,
            width: "100%",
            zIndex: 10,
          }}>
            {citySuggestions.map((city, i) => (
              <li
                key={i}
                onClick={() => handleSelectCity(city)}
                style={{ padding: "8px 12px", cursor: "pointer" }}
              >
                {city.name}, {city.country}
              </li>
            ))}
          </ul>
        )}
      </div>

      {loading && <p>Laster inn lokasjoner...</p>}

      {!loading && selectedCity && (
        <p>
          {locations.length} lokasjon{locations.length !== 1 ? "er" : ""} funnet nær {selectedCity.name}
        </p>
      )}

      {locations.map((loc) => (
        <div key={loc.id} display="flex" flexDirection="column" alignItems="center" marginBottom="20px">
          <div>
            <strong>{loc.locationName}</strong> - {loc.id}  — {loc._distanceKm} km fra {selectedCity?.name}
          </div>
          <img src={loc.mainProfileImage || "https://via.placeholder.com/150"} alt={loc.locationName} style={{ width: "150px", height: "150px", objectFit: "cover" }} />
          {loc?.profileImages && loc.profileImages.map((img, idx) => (
            <img key={idx} src={img} alt={`${loc.locationName} ${idx}`} style={{ width: "100px", height: "100px", objectFit: "cover", margin: "5px" }} />
          ))}
          <div><p>{loc.aboutBusiness}</p></div>
          <div><p>{loc.address}</p></div>
          <div>
            <strong>
                AllergenInfo:
            </strong>
            <p>{loc?.allergiesSubstitutes ? loc.allergiesSubstitutes.text : "null"}</p>
        </div></div>
      ))}
    </div>
  );
};

export default GetCityLocationsAdmin;